import { useQuery } from "@tanstack/react-query";
import { getBaseCaseApiUrl } from "../../../utils/environment";
import pathBuilders from "../../utils/pathBuilder";
import queryKeys from "../../utils/queryKeys";
import { makeApiRequest } from "../../useMakeRequest";
import {
  CaseTaxCal,
  CaseTaxCalStatus,
  caseTaxCalStatusSchema,
} from "./caseStatusGetApiTypes";
import { Case } from "./caseTypes";

type getStatusParams = {
  caseId: Case["id"];
};

const CALCSTATUS_POLLING_IN_MS = 1000 * 10; // 10 seconds

const isAnyCalcInProgress = (data: CaseTaxCal | undefined) =>
  data && isCalcStatusInProgress(data.caseStatus as CaseTaxCalStatus);

export const isCalcStatusInProgress = (caseStatus: CaseTaxCalStatus) =>
  [
    CaseTaxCalStatus.TAX_ENGINE_SCHEDULED,
    CaseTaxCalStatus.TAX_ENGINE_IN_PROGRESS,
    CaseTaxCalStatus.TRANSFER_DETECTION_IN_PROGRESS,
    CaseTaxCalStatus.FILE_INGESTION_IN_PROGRESS,
  ].includes(caseStatus);

export const getStatus = async ({ caseId }: getStatusParams) => {
  const baseUrl = getBaseCaseApiUrl();

  return makeApiRequest({
    baseUrl,
    urlPath: caseId && pathBuilders.buildCaseStatusPath(caseId),
    responseDataSchema: caseTaxCalStatusSchema,
  });
};

export const useGetCaseTaxCalcStatus = (caseId: Case["id"]) => {
  return useQuery({
    queryKey: queryKeys.getCaseStatusKey(caseId),
    queryFn: () => getStatus({ caseId }),
    refetchInterval: (data) =>
      isAnyCalcInProgress(data) ? CALCSTATUS_POLLING_IN_MS : false,
  });
};
